/**
 * Valid onboarding step IDs.
 * These represent the different steps in the user onboarding flow.
 */
export const ONBOARDING_STEP_IDS = [
  "profile",
  "billing",
  "product",
  "customize",
  "samples",
  "connect",
  "shipping",
  "publish",
] as const

export type OnboardingStepID = (typeof ONBOARDING_STEP_IDS)[number]
